<template>
    <div>
        <div class="panel-tag mt-3" v-if="totalEntries == 0">
            {{$t('table.no_records')}}
        </div>
        <div class="dataTables_wrapper dt-bootstrap4" v-show="totalEntries != 0">
            <div class="row" data-spy="scroll" data-target="#itemSP" data-offset="0">
                <div class="col-sm-12 overflow-auto">
                    <table id="commissionTypeTable" class="table table-sm table-hover table-bordered table-striped w-100 dataTable dtr-inline" role="grid" style="height: 1px">
                        <thead class="thead-themed">
                            <tr>
                                <th v-for="tblHeader in fields" :key="tblHeader.key" :style="{'width: 40%': tblHeader.key  == ''}" class="text-center">{{tblHeader.label}}</th>
                            </tr>
                        </thead>
                        <tr><td colspan="7" class="text-right pr-3">
                            <a class="btn btn-xs btn-outline-primary text-primary" @click="expandAll">{{isExpandAll == 'Expand' ? $t('button_link.expand_all') : $t('button_link.collapse_all')}}</a>
                        </td></tr>
                        <commissionTypeTable ref="serviceItem" :staffObj="staffObj" :items="serviceItems" :type="'service'" @setTotalEntries="setTotalEntries" @setExpandAll="setExpandAll"></commissionTypeTable>
                        <commissionTypeTable ref="productItem" :staffObj="staffObj" :items="productItems" :type="'product'" @setTotalEntries="setTotalEntries" @setExpandAll="setExpandAll"></commissionTypeTable>
                        <commissionTypeTable ref="packageItem" :staffObj="staffObj" :items="packageItems" :type="'package'" @setTotalEntries="setTotalEntries" @setExpandAll="setExpandAll"></commissionTypeTable>
                        <!-- <commissionTypeTable ref="discountItem" :items="discountItems" :type="'discount'" @setTotalEntries="setTotalEntries" @setExpandAll="setExpandAll"></commissionTypeTable> -->
                        <commissionTypeTable ref="outstandingsItem" :staffObj="staffObj" :items="outstandingsItem" :type="'outstandings'" @setTotalEntries="setTotalEntries" @setExpandAll="setExpandAll"></commissionTypeTable>
                    </table>
                </div>
            </div>
        </div>
        <div v-show="totalEntries != 0" class="dataTables_info" role="status" aria-live="polite">{{$t('table.pagination_short',{'totalEntries': totalEntries})}}</div>
    </div>
</template>
<script>
import _ from 'lodash';
import CommissionTypeTable from './Commission_TypeTable'
export default {
    name: 'commissionType',
    components:{
        CommissionTypeTable
    },
    props:{
        staffObj: { type: Object }
    },
    data(){
        return{
            totalEntries: 0,
            serviceItems: [],
            productItems: [],
            packageItems: [],
            discountItems: [],
            outstandingsItem: [],
            isExpandAll: "Expand", isExpandCount: 0
        }
    },
    computed:{
        fields(){
            return[
                { key: "index", label: "#"},
                { key: "", label: ""},
                { key: "totalQuantity", label: this.$i18n.t('table.header.total', {'item': this.$i18n.t('table.header.quantity')})},
                { key: "totalEffort", label: this.$i18n.t('table.header.total', {'item': this.$i18n.t('table.header.effort')})},
                { key: "totalFee", label: this.$i18n.t('table.header.total', {'item': this.$i18n.t('table.header.fee')})}
            ]
        }
    },
    methods:{
        updateTable(item){
            // var items = JSON.parse(item);
            var group = _.groupBy(item, 'item.type');  
            this.populateTable(group); 
            this.totalEntries = 0;
        },
        populateTable(item){
            this.serviceItems = "service" in item ? item["service"] : [];
            this.productItems = "product" in item ? item["product"] : [];
            this.packageItems = "package" in item ? item["package"] : [];
            // this.discountItems = "discount" in item ? item["discount"] : [];
            this.outstandingsItem = "outstandings" in item ? item["outstandings"] : [];
        },
        setTotalEntries(len){
            this.totalEntries += len
        },
        expandAll(){
            var isExpand = false;
            if(this.isExpandAll == "Expand"){
                isExpand = true;
                this.isExpandAll = "Collapse"
            }else{
                isExpand = false;
                this.isExpandAll = "Expand"
            }
            this.$refs.serviceItem.showAllDetails('service', isExpand);
            this.$refs.productItem.showAllDetails('product', isExpand);
            this.$refs.packageItem.showAllDetails('package', isExpand);
            // this.$refs.discountItem.showAllDetails('discount', isExpand);
            this.$refs.outstandingsItem.showAllDetails('outstandings', isExpand);
            
        },
        setExpandAll(status){
            if(status == "Collapse"){
                this.isExpandCount ++;
            }else{
                if(this.isExpandCount != 0)
                this.isExpandCount --;
            }
            var outletExpand = document.getElementById('commissionTypeTable').querySelectorAll(".typeExpand");
            if(outletExpand.length == this.isExpandCount){
                this.isExpandAll = "Collapse"
                this.isExpandCount = 0
            }else{
                this.isExpandAll = "Expand"
            }
        },
    },
}

</script>
<style scoped>
.btn-outline-primary:not(:disabled):not(.disabled):active,
.btn-outline-primary:not(:disabled):not(.disabled).active,
.show > .btn-outline-primary.dropdown-toggle,
.btn-outline-primary:hover{
    background: transparent;
    color: #62468d !important;
}
</style>
